export default "__VITE_ASSET__CK9rZ4Hg__"